import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import api from "@/lib/api";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }){
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  useEffect(()=>{
    const load = async () => {
      try {
        const res = await api.get(`/auth/me`);
        setUser(res.data);
      } catch {
        setUser(null);
      }
      setLoading(false);
    };
    load();
  },[]);
  if(loading) return <div className="min-h-screen flex items-center justify-center"><span data-testid="loading-indicator">Loading...</span></div>;
  if(!user) return <Navigate to="/login" replace/>;
  // Ensure children accepts {user,onLogout}; if element, clone; else render
  return React.isValidElement(children) ? React.cloneElement(children, { user, onLogout: ()=>{localStorage.removeItem('jwt_fallback'); setUser(null);} }) : children;
}

function App() {
  const [authedUser, setAuthedUser] = useState(null);
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login onAuthed={(u)=>setAuthedUser(u)} />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="/logout" element={<div data-testid="route-logout"/>} />
          <Route path="*" element={<Navigate to="/" replace/>} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
